function dcbFormatEUR(amount) {
  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(amount);
}

class DcbProductForm extends HTMLElement {
  connectedCallback() {
    // The section script can run before this element's children are parsed,
    // which would leave every querySelector null and no listeners attached.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
    } else {
      this.init();
    }
  }

  init() {
    this.state = { line: 'pure', facade: 'houtcomposiet' };
    this.lineBtns = this.querySelectorAll('[data-line-btn]');
    this.facadeBtns = this.querySelectorAll('[data-facade-btn]');
    this.facadesBlock = this.querySelector('[data-pdp-facades]');
    this.mainImage = this.querySelector('[data-pdp-main-image]');
    this.thumbs = this.querySelectorAll('[data-pdp-thumb]');
    this.variantInput = this.querySelector('[data-pdp-variant-input]');
    this.priceIncl = this.querySelector('[data-pdp-price-incl]');
    this.priceExcl = this.querySelector('[data-pdp-price-excl]');
    this.depositEl = this.querySelector('[data-pdp-deposit]');
    this.addLabel = this.querySelector('[data-pdp-add-label]');
    this.addBtn = this.querySelector('[data-pdp-add-btn]');
    this.addedBox = this.querySelector('[data-pdp-added]');
    this.lineLabel = this.querySelector('[data-pdp-line-label]');

    this.lineBtns.forEach((btn) => btn.addEventListener('click', () => this.selectLine(btn.getAttribute('data-line-btn'))));
    this.facadeBtns.forEach((btn) => btn.addEventListener('click', () => this.selectFacade(btn.getAttribute('data-facade-btn'))));
    this.thumbs.forEach((btn) => btn.addEventListener('click', () => this.selectThumb(btn)));
    if (this.addBtn) this.addBtn.addEventListener('click', () => this.addToCart());

    this.render();
  }

  currentVariantId() {
    if (this.state.line === 'pure') return this.dataset.pureVariant;
    if (this.state.facade === 'spiegelglas') return this.dataset.spiegelglasVariant;
    if (this.state.facade === 'corten') return this.dataset.cortenVariant;
    return this.dataset.houtcomposietVariant;
  }
  currentImage() {
    if (this.state.line === 'pure') return this.dataset.pureImage;
    if (this.state.facade === 'spiegelglas') return this.dataset.spiegelglasImage;
    if (this.state.facade === 'corten') return this.dataset.cortenImage;
    return this.dataset.houtcomposietImage;
  }
  currentDepositCents() {
    if (this.state.line === 'pure') return parseInt(this.dataset.purePrice, 10);
    return parseInt(this.dataset.houtcomposietPrice, 10);
  }

  selectLine(line) {
    this.state.line = line;
    if (line === 'studio') this.state.facade = this.state.facade || 'houtcomposiet';
    this.render();
  }
  selectFacade(facade) {
    this.state.facade = facade;
    this.render();
  }
  selectThumb(btn) {
    if (this.mainImage) this.mainImage.src = btn.getAttribute('data-image');
    this.thumbs.forEach((t) => t.classList.toggle('is-active', t === btn));
  }

  render() {
    const studio = this.state.line === 'studio';
    this.lineBtns.forEach((btn) => btn.classList.toggle('is-active', btn.getAttribute('data-line-btn') === this.state.line));
    if (this.facadesBlock) this.facadesBlock.hidden = !studio;
    this.facadeBtns.forEach((btn) => btn.classList.toggle('is-active', btn.getAttribute('data-facade-btn') === this.state.facade));

    if (this.mainImage) this.mainImage.src = this.currentImage();
    this.thumbs.forEach((t) => t.classList.remove('is-active'));

    const excl = studio ? parseFloat(this.dataset.studioExcl) : parseFloat(this.dataset.pureExcl);
    const incl = studio ? parseFloat(this.dataset.studioIncl) : parseFloat(this.dataset.pureIncl);
    if (this.priceIncl) this.priceIncl.textContent = dcbFormatEUR(incl);
    if (this.priceExcl) this.priceExcl.textContent = dcbFormatEUR(excl) + ' excl. btw';
    if (this.lineLabel) this.lineLabel.textContent = (studio ? 'Studio Collection · ' : 'Pure Collection · ') + (this.lineLabel.textContent.split('·')[1] || '').trim();

    // variant price is already tax-inclusive (store uses tax-inclusive pricing)
    const depositIncl = this.currentDepositCents() / 100;
    if (this.depositEl) this.depositEl.textContent = dcbFormatEUR(depositIncl);
    if (this.addLabel) this.addLabel.textContent = 'In winkelwagen · aanbetaling ' + dcbFormatEUR(depositIncl);

    if (this.variantInput) this.variantInput.value = this.currentVariantId();
    if (this.addedBox) this.addedBox.hidden = true;
  }

  addToCart() {
    const id = this.currentVariantId();
    if (this.addBtn) this.addBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
    })
      .then((r) => r.json())
      .then(() => fetch('/cart.js'))
      .then((r) => r.json())
      .then((cart) => {
        document.dispatchEvent(new CustomEvent('dcb:cart-updated', { detail: { item_count: cart.item_count } }));
        if (this.addedBox) this.addedBox.hidden = false;
        if (this.addLabel) this.addLabel.textContent = 'Toegevoegd · nog een toevoegen';
      })
      .catch(() => {})
      .finally(() => {
        if (this.addBtn) this.addBtn.disabled = false;
      });
  }
}
customElements.define('dcb-product-form', DcbProductForm);
